// Vehicle data for Keller Motors lineup
export const VEHICLES = {
  adler: {
    id: "adler",
    name: "Adler",
    tagline: "The Flagship Hypercar",
    edition: "Heimat Edition",
    description: "The symbol of our intent. A reimagined Group C race car for the road and track. Carbon monocoque chassis, underbody fan system generating 3,000lbs of downforce, and the raw mechanical connection that modern supercars have abandoned.",
    price: "$400,000",
    priceNote: "Heimat Edition: $500,000",
    specs: {
      power: "800 HP",
      torque: "650 lb-ft",
      weight: "2,000 lbs",
      acceleration: "2.5s 0-60",
      topSpeed: "200+ mph",
      downforce: "3,000 lbs @ 150mph",
      engine: "3.5L Twin-Turbo V6 (VQ35DET)",
      transmission: "6-Speed Manual (H-Pattern or Sequential)",
      drivetrain: "Mid-Engine RWD"
    },
    features: [
      "Carbon monocoque chassis",
      "Underbody fan system",
      "Mechanically adjustable pushrod suspension",
      "Mechanical limited slip differential",
      "Cable-operated throttle",
      "Gated shifter with exposed linkage",
      "Analog gauges",
      "4-point racing harnesses",
      "100,000+ mile warranty"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_pre-order-hub/artifacts/my1fu1ea_scene%201.jpg",
      "https://customer-assets.emergentagent.com/job_pre-order-hub/artifacts/oh96chad_Scene%202.jpg",
      "https://customer-assets.emergentagent.com/job_pre-order-hub/artifacts/4qo602aa_Scene%203.jpg"
    ],
    timeline: "Test drive in ~3 months, delivery in ~9 months",
    available: true
  },
  falke: {
    id: "falke",
    name: "Falke",
    tagline: "The Adler's Little Brother",
    edition: "In Development",
    description: "A mid-engine, tubular-chassis weapon powered by the same VQ35DE that beats in the Adler. Tubular steel chassis with composite body panels, perfect 50/50 weight distribution, and modular aerodynamics allowing 500-1,500lbs of adjustable downforce. All the mechanical purity of the flagship, at a fraction of the cost.",
    price: "$120,000",
    priceNote: "Estimated pricing (±20%)",
    specs: {
      power: "800 HP",
      torque: "650 lb-ft",
      weight: "~2,200 lbs",
      acceleration: "~3.0s 0-60",
      topSpeed: "190+ mph",
      downforce: "500-1,500 lbs (adjustable)",
      engine: "3.5L Twin-Turbo V6 (VQ35DE)",
      transmission: "6-Speed Manual (H-Pattern or Sequential)",
      drivetrain: "Mid-Engine RWD"
    },
    features: [
      "Tubular steel chassis",
      "Composite body panels",
      "50/50 weight distribution",
      "Modular aero fins and adjustable wing",
      "Pushrod suspension",
      "Mechanical limited slip differential",
      "Cable-operated throttle"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_pre-order-hub/artifacts/y7pqzxh6_IMG-20260106-WA0005.jpg"
    ],
    timeline: "Production begins ~6 months after Adler delivery",
    available: true
  },
  quelle: {
    id: "quelle",
    name: "Quelle",
    tagline: "The Front-Engine Supercar",
    edition: "In Development",
    description: "A front-engine, tubular-chassis weapon using the legendary Toyota 1JZ. Like a Dodge Viper on steroids. The same uncompromising mechanical philosophy as the Falke, with classic grand-tourer proportions.",
    price: "$120,000",
    priceNote: "Estimated pricing (±20%)",
    specs: {
      power: "800 HP",
      torque: "TBD",
      weight: "~2,400 lbs",
      acceleration: "~3.2s 0-60",
      topSpeed: "185+ mph",
      downforce: "Adjustable",
      engine: "Toyota 1JZ (built to spec)",
      transmission: "6-Speed Manual (H-Pattern or Sequential)",
      drivetrain: "Front-Engine RWD"
    },
    features: [
      "Tubular steel chassis",
      "Composite body panels",
      "Classic front-engine proportions",
      "Pushrod suspension",
      "Mechanical limited slip differential",
      "Cable-operated throttle"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_pre-order-hub/artifacts/jfzrm6jn_IMG-20260106-WA0004.jpg"
    ],
    timeline: "Estimated delivery in ~2 years",
    available: true
  },
  ritter: {
    id: "ritter",
    name: "Ritter",
    tagline: "A Corvette ZR1 for Half the Price",
    edition: "In Development",
    description: "A lightweight, 800hp sports car for less than the price of a Porsche 911. The Ritter delivers hypercar performance in a package built for the road — the driver's weapon of choice.",
    price: "$80,000",
    priceNote: "Estimated pricing (±20%)",
    specs: {
      power: "800 HP",
      torque: "TBD",
      weight: "Lightweight",
      acceleration: "TBD",
      topSpeed: "TBD",
      downforce: "TBD",
      engine: "TBD",
      transmission: "6-Speed Manual",
      drivetrain: "RWD"
    },
    features: [
      "Lightweight construction",
      "800 HP powertrain",
      "Cable-operated throttle",
      "Mechanical limited slip differential",
      "Analog gauges",
      "Driver-focused ergonomics"
    ],
    images: [],
    timeline: "Design phase — updates coming",
    available: true
  },
  koenig: {
    id: "koenig",
    name: "König",
    tagline: "Torque to Tow an Aircraft Carrier",
    edition: "In Development",
    description: "A luxurious executive sedan with zero electronics and enough torque to move mountains. Like a classic Mercedes S-Class with four times the horsepower — analog luxury, mechanical dignity, engineered to last a century.",
    price: "$80,000",
    priceNote: "Estimated pricing (±20%)",
    specs: {
      power: "Twin-Turbo V8",
      torque: "Massive",
      weight: "TBD",
      acceleration: "TBD",
      topSpeed: "TBD",
      downforce: "N/A",
      engine: "Top Secret Twin-Turbo V8",
      transmission: "6-Speed Manual",
      drivetrain: "RWD"
    },
    features: [
      "Classic executive sedan proportions",
      "Premium analog materials throughout",
      "Zero electronic driver aids",
      "Twin-turbo V8 power",
      "Modern restomod philosophy",
      "Analog luxury experience"
    ],
    images: [],
    timeline: "Design phase — updates coming",
    available: true
  },
  stein: {
    id: "stein",
    name: "Stein",
    tagline: "Rally Stage to Soccer Practice",
    edition: "In Development",
    description: "A capable, driver-focused SUV that can actually go from a rally stage to soccer practice. Analog controls, real off-road capability, and the same mechanical honesty as every Keller Motors vehicle.",
    price: "$50,000",
    priceNote: "Estimated pricing (±20%)",
    specs: {
      power: "TBD",
      torque: "TBD",
      weight: "TBD",
      acceleration: "TBD",
      topSpeed: "TBD",
      downforce: "N/A",
      engine: "TBD",
      transmission: "Manual",
      drivetrain: "AWD"
    },
    features: [
      "Driver-focused ergonomics",
      "Rally-capable suspension",
      "Analog controls throughout",
      "Family-friendly practicality",
      "Real off-road capability"
    ],
    images: [],
    timeline: "Design phase — updates coming",
    available: true
  },
  enz: {
    id: "enz",
    name: "Enz",
    tagline: "The Market Disruptor",
    edition: "In Development",
    description: "A rally sedan and hatchback for the street with up to 800hp, powered by the legendary Mitsubishi 4G63. Basically an Evo 8/9 — but the turbo is twice as big. Available as a naturally aspirated daily driver all the way up to a full race-spec monster.",
    price: "From $10,000",
    priceNote: "Base model starting price",
    specs: {
      power: "Up to 800 HP",
      torque: "Up to 500+ lb-ft",
      weight: "~2,800 lbs",
      acceleration: "As low as 3.5s 0-60 (Turbo R)",
      topSpeed: "160+ mph",
      downforce: "Available on Turbo R",
      engine: "Mitsubishi 4G63 Turbo",
      transmission: "5-Speed Manual",
      drivetrain: "FWD (Base) / AWD (Turbo & Turbo R)"
    },
    variants: [
      { name: "Base", price: "$10,000", power: "~200 HP", drive: "FWD", description: "Naturally aspirated daily driver" },
      { name: "Turbo", price: "$30,000", power: "400 HP", drive: "AWD", description: "Turbocharged all-wheel drive" },
      { name: "Turbo R", price: "$50,000", power: "800 HP", drive: "AWD", description: "Full race-spec monster" }
    ],
    features: [
      "2-door hatch or 4-door sedan body styles",
      "Mitsubishi 4G63 engine platform",
      "Oversized turbo (Turbo & Turbo R)",
      "AWD system (Turbo & Turbo R)",
      "Mechanical limited slip differential",
      "Rally-inspired suspension"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_pre-order-hub/artifacts/yh6o7wsx_IMG-20260106-WA0007.jpg"
    ],
    timeline: "Estimated delivery in ~3 years",
    available: true
  },
  panzer: {
    id: "panzer",
    name: "Panzer",
    tagline: "For the Blue-Collar Boys",
    edition: "In Development",
    description: "A rugged, analog pickup truck developed specifically for contractors. LS motor, manual V8, and no fragile electronics to strand you on a job site. Real capability without the tech complexity that plagues modern trucks.",
    price: "TBA",
    priceNote: "Pricing in development",
    specs: {
      power: "V8 Power",
      torque: "Truck torque",
      weight: "TBD",
      acceleration: "TBD",
      topSpeed: "TBD",
      downforce: "N/A",
      engine: "Chevy LS V8",
      transmission: "Manual",
      drivetrain: "RWD / 4WD"
    },
    features: [
      "LS V8 manual powertrain",
      "Built for contractors",
      "Zero fragile electronics",
      "Real work-truck capability",
      "Mechanical simplicity throughout"
    ],
    images: [],
    timeline: "Design phase — updates coming",
    available: true
  }
};

export const VEHICLE_LIST = Object.values(VEHICLES);

// Image assets
export const IMAGES = {
  engine: {
    block: "https://customer-assets.emergentagent.com/job_pre-order-hub/artifacts/d5hrbhoy_20230609_085326.jpg",
    dressed: "https://customer-assets.emergentagent.com/job_pre-order-hub/artifacts/jwhnb8j5_20230704_142531%281%29.jpg"
  },
  atmospheric: [
    "https://images.unsplash.com/photo-1551272741-d9d0c434362e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxtb3VudGFpbiUyMGRyaXZpbmclMjByb2FkJTIwbWlzdHxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NzcyODg2ODh8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1559759748-029511daa8aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxtb3VudGFpbiUyMGRyaXZpbmclMjByb2FkJTIwbWlzdHxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NzcyODg2ODh8MA&ixlib=rb-4.1.0&q=85"
  ]
};
